import { watch, ref, onMounted, computed } from "vue";
import { msalInstance } from "@/authConfig";
import { alertFailed } from "@/composables/swAlert";
import { useFetchJSONFCH } from "@/functions/getBaseUrl";
import store from "@/store";

// INSERIRE ECCEZIONI PER LE PAGINE NO AUTH
// ?k=FIT0002491&y=CT

export default function useSSOFunction() {
  const puoNavigare = ref(false);
  const payloadRequests = ref({ id_user: localStorage.getItem("guid") });
  const { execute: executeLogout, statusCode } =
    useFetchJSONFCH("v1/sso/logout").post(payloadRequests);

  const { execute: executeLogin, statusCode: statusCodeLogin } =
    useFetchJSONFCH("v1/sso/login").post(payloadRequests);

  const { execute: executeStatus, statusCode: statusCodeStatus } =
    useFetchJSONFCH("v1/sso/user/status").post(payloadRequests);

  const isUnauthenticatedUrl = computed(() => {
    const urlParams = new URLSearchParams(window.location.search);

    return (
      window.location.href.includes("vt") &&
      urlParams.has("k") &&
      urlParams.has("y")
    );
  });

  const loginFunction = async () => {
    if (isUnauthenticatedUrl.value) {
      puoNavigare.value = true;

      return;
    }
    payloadRequests.value.id_user = localStorage.getItem("guid");

    await executeLogin();
  };
  const statusFunction = async () => {
    if (!localStorage.getItem("guid") || isUnauthenticatedUrl.value) {
      puoNavigare.value = true;

      return;
    }
    payloadRequests.value.id_user = localStorage.getItem("guid")
      ? localStorage.getItem("guid")
      : localStorage.getItem(
          "msal.35563259-3640-454c-8b47-0a222310a865.active-account"
        );

    await executeStatus();

    if (statusCodeStatus.value != 200) {
      localStorage.clear();
      msalInstance.logoutRedirect();
      alertFailed("Per continuare, effettuare nuovamente il login").then(() => {
        localStorage.clear();
        msalInstance.logoutRedirect();
      });
    } else {
      puoNavigare.value = true;
    }
  };

  const logoutFunction = async () => {
    payloadRequests.value.id_user = localStorage.getItem("guid");
    await executeLogout();
    if (statusCode.value === 200 || statusCode.value === 525) {
      localStorage.clear();
      puoNavigare.value = true;
      msalInstance.logoutRedirect();
    }
  };

  return {
    statusFunction,
    loginFunction,
    logoutFunction,
    statusCodeLogin,
    statusCodeStatus,
    puoNavigare,
  };
}
